import {
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  Radar,
} from 'recharts';

export interface VoteStats {
  proposalsCreated: number;
  votedYes: number;
  votedNo: number;
  votedAbstain: number;
}

export interface ProposalStats {
  succeeded: number;
  failed: number;
  active: number;
  pending: number;
  canceled: number;
}

interface VoteStatsProps {
  voteStats: VoteStats;
  proposalStats: ProposalStats;
}

const VoteStats: React.FC<VoteStatsProps> = ({ voteStats, proposalStats }) => {
  const radarData = [
    {
      subject: `Succeeded (${proposalStats.succeeded})`,
      value: proposalStats.succeeded,
    },
    {
      subject: `Failed (${proposalStats.failed})`,
      value: proposalStats.failed,
    },
    {
      subject: `Active (${proposalStats.active})`,
      value: proposalStats.active,
    },
    {
      subject: `Pending (${proposalStats.pending})`,
      value: proposalStats.pending,
    },
    {
      subject: `Canceled (${proposalStats.canceled})`,
      value: proposalStats.canceled,
    },
  ];

  return (
    <div className="mt-8 p-6 border border-neutral-700 rounded-lg">
      <h2 className="text-xl font-bold mb-6">Statistics</h2>

      <div className="flex flex-col lg:flex-row justify-between gap-8">
        {/* Voting Statistics */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-4 text-yellow">Voting Activity</h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 border border-neutral-700 rounded-lg">
              <div className="text-sm text-neutral-400">Proposals Created</div>
              <div className="text-2xl font-bold">{voteStats.proposalsCreated}</div>
            </div>
            <div className="p-4 border border-neutral-700 rounded-lg">
              <div className="text-sm text-neutral-400">Voted Yes</div>
              <div className="text-2xl font-bold text-voteYes">{voteStats.votedYes}</div>
            </div>
            <div className="p-4 border border-neutral-700 rounded-lg">
              <div className="text-sm text-neutral-400">Voted No</div>
              <div className="text-2xl font-bold text-voteNo">{voteStats.votedNo}</div>
            </div>
            <div className="p-4 border border-neutral-700 rounded-lg">
              <div className="text-sm text-neutral-400">Abstained</div>
              <div className="text-2xl font-bold text-voteAbstain">
                {voteStats.votedAbstain}
              </div>
            </div>
          </div>
        </div>

        {/* Proposal Status Chart */}
        <div className="flex-1">
          <h3 className="text-lg font-semibold mb-4 text-yellow">Proposal Outcomes</h3>
          <div className="h-[300px] w-full">
            <ResponsiveContainer width="100%" height="100%">
              <RadarChart data={radarData}>
                <PolarGrid stroke="#404040" />
                <PolarAngleAxis dataKey="subject" tick={{ fill: '#A3A3A3' }} />
                <Radar
                  name="Proposals"
                  dataKey="value"
                  stroke="#EAB308"
                  fill="#EAB308"
                  fillOpacity={0.3}
                />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoteStats;
